(() => {
  function initialize(root) {
    if (!root || root.dataset.chaptersReady) return;
    root.dataset.chaptersReady = 'true';
    const panels = [...root.querySelectorAll('.multirow__inner > .image-with-text')];
    panels.forEach((panel, index) => {
      const content = panel.querySelector('.image-with-text__content');
      const headingLink = panel.querySelector('.image-with-text__heading a');
      if (!content) return;
      const number = document.createElement('span');
      number.className = 'collection-chapter__number';
      number.textContent = `${String(index + 1).padStart(2, '0')} / ${String(panels.length).padStart(2, '0')}`;
      content.prepend(number);
      if (headingLink) {
        const link = document.createElement('a');
        link.className = 'collection-chapter__link';
        link.href = headingLink.href;
        link.textContent = `Explore ${headingLink.textContent.replace(/ collection/i, '').trim()} ↗`;
        content.append(link);
      }
    });
    const motion = window.matchMedia('(min-width: 750px) and (min-height: 651px) and (prefers-reduced-motion: no-preference)');
    let frame;
    let visible = false;
    const update = () => {
      frame = null;
      if (!motion.matches || !visible) return;
      const height = window.innerHeight;
      const rootBounds = root.getBoundingClientRect();
      panels.forEach((panel, index) => {
        const progress = Math.max(0, Math.min(1, (-rootBounds.top - index * panel.offsetHeight) / height));
        panel.style.setProperty('--chapter-scale', (1 + progress * .055).toFixed(3));
        panel.style.setProperty('--chapter-offset', `${-progress * 16}px`);
      });
    };
    const schedule = () => { if (!frame && visible) frame = requestAnimationFrame(update); };
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; schedule(); });
    observer.observe(root);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    motion.addEventListener('change', schedule);
    const cleanup = (event) => {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      motion.removeEventListener('change', schedule);
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
  }
  document.querySelectorAll('[id*="phyto_collections_stack"].shopify-section').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.id.includes('phyto_collections_stack')) initialize(event.target);
  });
})();
